<div class="room-plan" #grid [class.room-plan--single-row]="singleRow()">
  @for (tile of tiles(); track tile.room.roomId) {
    <andor-room-plan-tile
      role="button"
      tabindex="0"
      [attr.data-room-id]="tile.room.roomId"
      [attr.aria-label]="tile.room.name"
      [attr.aria-pressed]="tile.room.roomId === selectedRoomId()"
      [room]="tile.room"
      [doorSide]="tile.doorSide"
      [now]="now()"
      [bypassesGate]="bypassesGate()"
      [highlighted]="tile.room.roomId === selectedRoomId()"
      (click)="roomSelected.emit(tile.room)"
      (keydown.enter)="roomSelected.emit(tile.room)" />
  } @empty {
    <div class="empty">{{ 'No rooms available' | translate }}</div>
  }
</div>
